import './src/styles/global.scss';
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LedBsohAAAAANNy6KeRtXbIGLHAXovZYl2a_ZDO">
      {element}
    </GoogleReCaptchaProvider>
  );
};
